import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=f2d4d7fa&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=f2d4d7fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d4d7fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2d4d7fa')) {
      api.createRecord('f2d4d7fa', component.options)
    } else {
      api.reload('f2d4d7fa', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=f2d4d7fa&scoped=true&", function () {
      api.rerender('f2d4d7fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gC2z502njizR/JS/comp/PopupDialog.vue"
export default component.exports